// extracted by mini-css-extract-plugin
export default {"pageLoading":"pageLoading_afd08"};